import { AllotmentRolesConstants as Roles } from '@/stores/definitions.js';
import { RouteRecordRaw } from 'vue-router';
import { lazyRoute, meta } from '@/router/router-helpers.ts';

const FinanceView = () => import('@/views/Finance/Finance.vue');
const ALLOTMENT_APP_ID = 'allotment' as const;

const financeRoutes: RouteRecordRaw[] = [
  lazyRoute('finance', FinanceView, {
    path: '/finance',
    meta: meta({
      app: ALLOTMENT_APP_ID,
      allowedRoles: [Roles.FINANCE],
      title: 'Finance',
      referenceDataRequired: true,
    }),
  }),
];

export default financeRoutes;
